export const booleanFromString = (str?: string) => {
	return (
		str === '1' ||
		str === 'X' ||
		str?.toLowerCase() === 'true' ||
		str === 'Y' ||
		str === 'YES'
	)
}
